function joinNaturalSpanishList(parts) {
  const p = (parts || []).filter(Boolean);
  if (p.length === 0) return '';
  if (p.length === 1) return p[0];
  if (p.length === 2) return `${p[0]} y ${p[1]}`;
  return `${p.slice(0, -1).join(', ')} y ${p[p.length - 1]}`;
}

export function matchesCoreBusinessPaymentIntent(n) {
  if (/\b(cuanto|precio del|el menu|el menú|recomienda|mejor)\b/.test(n) && !/\b(pago|pagar|acept|tarjeta|efect|transfer|mercado)\b/.test(n)) {
    return false;
  }
  return (
    /\b(como pago|como pa[g]o|medios? de pago|formas? de pago|que aceptan)\b/.test(n) ||
    (/\b(aceptan|pagan|aceptais|cobr[aá]n|tienen)\b/.test(n) &&
      /\b(efectivo|tarjeta|transfer|mercado|debito|credito|plata|visa|redcompra)\b/.test(n)) ||
    (/\b(pago|pagar|pagan|pagas|pague)\b/.test(n) && /\b(efectivo|tarjeta|transfer|mercado|debito|credito|plata|aceptan|formas?)\b/.test(n))
  );
}

export function formatCoreBusinessPaymentBlock(business) {
  const b = business || {};
  const parts = [];
  if (b.accepts_cash !== false) parts.push('efectivo');
  if (b.accepts_transfer !== false) parts.push('transferencia');
  if (b.accepts_card === true) parts.push('tarjeta (en el local)');
  if (b.accepts_mercadopago === true) parts.push('Mercado Pago (el local manda el link o lo coordinan al pedir)');
  if (parts.length === 0) {
    return '💳 No tengo todavía medios de pago cargados para este local acá. Podés revisar en el menú o escribir por WhatsApp y te lo confirman al tiro.';
  }
  return `💳 Aceptamos ${joinNaturalSpanishList(parts)}. Lo cerrás al armar el pedido.\n\nSi no te cierra, mirá en el menú o preguntale al local.`;
}
